import { useRef, useState } from "react";
import { FaCheck } from "react-icons/fa";
import { Button, ButtonProps, useToast } from "@chakra-ui/react";
import * as Sentry from "@sentry/react";
import { useMutation } from "graphql-hooks";

import { GENERATE_PAYMENT_LINK } from "../../../../data/mutations";
import {
  GeneratePaymentLinkMutation,
  OrderPayment,
  OrderPaymentStatus,
} from "../../../../types";

import { payOnce } from "./pay";

export default ({
  orderId,
  payment,
  buttonProps,
}: {
  orderId: string;
  payment: OrderPayment;
  buttonProps?: ButtonProps;
}) => {
  const [generatePaymentLink] = useMutation<GeneratePaymentLinkMutation>(
    GENERATE_PAYMENT_LINK
  );
  const toast = useToast();
  // One P24 transaction per click: a double click created two (ACZW-CNK2-49KX, staging)
  const inFlight = useRef(false);
  const [isBusy, setIsBusy] = useState(false);

  const pay = () =>
    payOnce(inFlight, {
      request: () =>
        generatePaymentLink({
          variables: { orderId, paymentId: payment.id },
        }),
      navigate: (link) => window.location.assign(link),
      setBusy: setIsBusy,
      onError: (message, details) => {
        // Correlates with the backend logs, which carry the same order and payment ids
        Sentry.captureMessage("Payment link redirect failed", {
          level: "warning",
          extra: { orderId, paymentId: payment.id, details },
        });
        toast({ status: "error", isClosable: true, description: message });
      },
    });

  if (payment.status === OrderPaymentStatus.Paid) {
    return (
      <Button
        {...buttonProps}
        leftIcon={<FaCheck />}
        colorScheme={"green"}
        isDisabled={true}
      >
        {"Opłacone"}
      </Button>
    );
  }
  return (
    <Button
      {...buttonProps}
      isLoading={isBusy}
      colorScheme={"blue"}
      onClick={pay}
    >
      Zapłać
    </Button>
  );
};
